module.exports = __webpack_public_path__ + "fd5ea41ad2bd2d06d18e78e38fcd6069.svg";